import { helpers, enumHelper, cartManager } from "@/utilities";
import objectAddress from "@/model/address";
import Vue from "vue";
import i18n from '../i18n'
import _ from "lodash";
import 'moment/locale/es'
import 'moment/locale/en-gb'
import {
  isChrome,
  isFirefox,
  isSafari,
  isOpera,
  isIE,
  isEdge,
  isYandex,
  isChromium,
  isMobileSafari,
} from "mobile-device-detect";
export default {
  getBaseUrl: () => {
    return window.location.origin;
  },
  getStripeKey: () => {
    return process.env.VUE_APP_STRIPE_KEY;
  },
  getStripeApiVersion: () => {
    return process.env.VUE_APP_STRIPE_API_VERSION
      ? process.env.VUE_APP_STRIPE_API_VERSION
      : "2015-04-07";
  },
  getOrderTotal: (cart, order_type) => {
    if (!cart.order || cart.order.length <= 0) return 0;
    let total = 0;
    for (let i = 0; i < cart.order.length; i++) {
      total += helpers.getItemTotal(cart.order[i], order_type);
    }
    return total;
  },
  getItemTotal: (item, order_type) => {
    if (item == null) return 0;
    let itemTotal = helpers.getMenuItemPrice(item, order_type) * item.quantity;

    if (!item.hasOptions) return itemTotal;

    item.options.forEach((option) => {
      if (
        (option.type == "RADIO" || option.type == "SELECT") &&
        option.selected != ""
      ) {
        //--- get the price of the selected option
        let price = option.values.find((x) => x.id == option.selected).price;
        itemTotal += price * item.quantity;
      } else if (option.type == "CHECKBOX" && option.selected.length > 0) {
        option.selected.forEach((val) => {
          if (val) {
            let price = option.values.find((x) => x.id == val).price;
            itemTotal += price * item.quantity;
          }
        });
      }
    });
    return itemTotal;
  },

  getOriginItemTotal(item, order_type) {
    if (item == null) return 0;

    let itemPriceTotal =
      helpers.getMenuItemPrice(item.menuItem, order_type) * item.quantity;

    if (item.hasOptions) return itemPriceTotal;

    let optionsPriceTotal = 0;
    item.options.forEach((option) => {
      option.values.forEach((val) => {
        //*** get the original price of the selected value */
        let originalValue = null;
        item.menuItem.options.find((orgOption) => {
          originalValue = orgOption.values.find((orgValue) => {
            return orgValue.id == val.menu_option_value_id;
          });
          if (originalValue) {
            optionsPriceTotal += originalValue.price * option.quantity;
          }
        });
      });
    });
    return itemPriceTotal + optionsPriceTotal;
  },
  getReOrderItemTotal(item) {
    if (item == null) return 0;

    let itemPriceTotal = item.price * item.quantity;

    if (item.options.length === 0) return itemPriceTotal;

    let optionsPriceTotal = 0;
    item.options.forEach((option) => {
      option.values.forEach((val) => {
        if (val) {
          optionsPriceTotal += val.price * option.quantity;
        }
      });
    });
    return itemPriceTotal + optionsPriceTotal;
  },

  generateAddress: (place, placeResultData) => {
    let _currentAddress = objectAddress;

    placeResultData.address_components.forEach(function (details) {
      switch (details.types[0]) {
        case "street_number":
          _currentAddress.address_line_1 = details.long_name;
          break;
        case "route":
          _currentAddress.address_line_2 = details.long_name;
          break;
        case "postal_town" || "administrative_area_level_2":
          if (_currentAddress.city == "")
            _currentAddress.city = details.long_name;
          break;
        case "administrative_area_level_1":
          _currentAddress.region = details.long_name;
          break;
        case "country":
          _currentAddress.country = details.long_name;
          break;
        case "postal_code" || "postal_code_prefix":
          _currentAddress.postcode = details.long_name;
          break;
      }
    });
    _currentAddress.lat = place.latitude;
    _currentAddress.lng = place.longitude;
    return _currentAddress;

    /* _currentAddress.address_line_1 = addData.street_number;
    if (addData.street_number == "") {
      _currentAddress.address_line_1 =
        placeResultData.address_components[0].long_name;
    }
    _currentAddress.address_line_2 = addData.route;
    if (
      placeResultData.address_components[1].long_name != "" ||
      placeResultData.address_components[2].long_name
    ) {
      _currentAddress.address_line_2 =
        placeResultData.address_components[1].long_name +
        " " +
        placeResultData.address_components[2].long_name;
    }
    _currentAddress.postcode = addData.postal_code;
    if (addData.postal_code == "") {
      _currentAddress.postcode =
        placeResultData.address_components[7].long_name;
    }
    _currentAddress.country = addData.country;
    if (addData.country == "") {
      _currentAddress.country = placeResultData.address_components[6].long_name;
    }
    _currentAddress.region = addData.administrative_area_level_1;
    _currentAddress.lat = addData.latitude;
    _currentAddress.lng = addData.longitude;
    _currentAddress.city = placeResultData.address_components[3].long_name;*/
  },

  canMakeOrder: (selectedLocation, isMounted = true) => {
    let status = {
      open: false,
      can_make_order: false,
      accepts_future_orders: false,
      can_accept_delivery: false,
      can_accept_collection: false,
      can_accept_tableOrdering: false,
      openingHours: selectedLocation ? selectedLocation.openingHours : [],
    };

    if (
      _.isEmpty(selectedLocation) ||
      !isMounted ||
      selectedLocation.openingHours.suspended
    )
      return status;

    status.open =
      selectedLocation.openingHours.delivery ||
      selectedLocation.openingHours.collection ||
      selectedLocation.openingHours.sitIn;
    status.accepts_future_orders =
      selectedLocation.orderSetting.accepts_future_orders;
    status.openingHours = selectedLocation.openingHours;

    //--- a user can order only if the location is open or accept_future_orders and today is included in one of (delivery_time or pick_time)
    //let delivery_time = selectedLocation.delivery_time;

    const canAcceptDelivery =
      status.openingHours.delivery ||
      helpers.isDeliveryTypeAvailble(
        selectedLocation.delivery_time,
        selectedLocation.orderSetting
      );

    const canAcceptCollection =
      //status.openingHours.collection ||
      helpers.isCollectionTypeAvailble(
        selectedLocation.pickup_time,
        selectedLocation.orderSetting
      );

    const canAcceptTableOrdering =
      status.openingHours.sitIn &&
      helpers.isTableTypeAvailble(selectedLocation.tableOrdering_time);

    status.can_accept_delivery =
      selectedLocation.orderSetting.offer_delivery && canAcceptDelivery;
    status.can_accept_collection =
      selectedLocation.orderSetting.offer_collection && canAcceptCollection;
    status.can_accept_tableOrdering =
      selectedLocation.orderSetting.offer_tableordering &&
      canAcceptTableOrdering;

    status.can_make_order =
      canAcceptDelivery || canAcceptCollection || canAcceptTableOrdering;

    return status;
  },

  isDeliveryTypeAvailble(dates_collection, settings) {
    let array_dates = Object.keys(dates_collection);

    if (!array_dates.length) return false;

    let now = Vue.prototype.$moment(new Date());

    let future_order_time = settings.accepts_future_orders
      ? settings.future_order_delivery
      : 0;

    for (let k = 0; k < array_dates.length; k++) {
      let str_elemnt = array_dates[k];
      var date_values = dates_collection[str_elemnt];
      if (!date_values) continue;
      let date_element = Vue.prototype.$moment(str_elemnt, "YYYY-MM-DD"); // display only time or Tomorrow + time or day name + time

      //--- if the first element is today
      if (date_element.isSame(Vue.prototype.$moment(now), "day")) {
        //--- check the time depend on today
        for (let i = 0; i < date_values.length; i++) {
          let full_open_at = Vue.prototype.$moment(
            now.format("YYYY-MM-DD") + " " + date_values[i].opens_at,
            "YYYY-MM-DD HH:mm:ss"
          );
          let full_close_at = Vue.prototype.$moment(
            now.format("YYYY-MM-DD") + " " + date_values[i].closes_at,
            "YYYY-MM-DD HH:mm:ss"
          );

          let now_with_future = Vue.prototype.$moment(
            Vue.prototype
              .$moment(
                full_open_at
                  .clone()
                  .subtract(future_order_time, "h")
                  .toDate()
              )
              .format("YYYY-MM-DD HH:mm:ss"),
            "YYYY-MM-DD HH:mm:ss"
          );
          if (
            (now.isSameOrAfter(full_open_at) &&
              now.isSameOrBefore(full_close_at)) ||
            (settings.accepts_future_orders &&
              now.isSameOrAfter(now_with_future) &&
              now.isSameOrBefore(full_open_at))
          ) {
            return true;
          }
        }
      } else if (settings.accepts_future_orders && date_element.isAfter(now)) {
        // date is in the futur
        return true;
      }
    }
    Vue.nextTick(() => {
      return false;
    });
  },

  isCollectionTypeAvailble(dates_collection, settings) {
    let array_dates = Object.keys(dates_collection);

    if (!array_dates.length) return false;

    let now = Vue.prototype.$moment(new Date());

    let future_order_time = settings.accepts_future_orders
      ? settings.future_order_collection
      : 0;

    for (let k = 0; k < array_dates.length; k++) {
      let str_elemnt = array_dates[k];
      var date_values = dates_collection[str_elemnt];
      if (!date_values) continue;
      let date_element = Vue.prototype.$moment(str_elemnt, "YYYY-MM-DD"); // display only time or Tomorrow + time or day name + time

      //--- if the first element is today
      if (date_element.isSame(Vue.prototype.$moment(now), "day")) {
        //--- check the time depend on today
        for (let i = 0; i < date_values.length; i++) {
          let full_open_at = Vue.prototype.$moment(
            now.format("YYYY-MM-DD") + " " + date_values[i].opens_at,
            "YYYY-MM-DD HH:mm:ss"
          );
          let full_close_at = Vue.prototype.$moment(
            now.format("YYYY-MM-DD") + " " + date_values[i].closes_at,
            "YYYY-MM-DD HH:mm:ss"
          );

          let now_with_future = Vue.prototype.$moment(
            Vue.prototype.$moment(
              full_open_at
                .clone()
                .subtract(future_order_time, "h")
                .toDate()
            )
              .format("YYYY-MM-DD HH:mm:ss"),
            "YYYY-MM-DD HH:mm:ss"
          );
          if (
            (now.isSameOrAfter(full_open_at) &&
              now.isSameOrBefore(full_close_at)) ||
            (settings.accepts_future_orders &&
              now.isSameOrAfter(now_with_future) &&
              now.isSameOrBefore(full_open_at))
          ) {
            return true;
          }
        }
      } else if (settings.accepts_future_orders && date_element.isAfter(now)) {
        // date is in the futur
        return true;
      }
    }
    Vue.nextTick(() => {
      return false;
    });
  },

  isTableTypeAvailble(dates_collection) {
    let array_dates = Object.keys(dates_collection);

    if (!array_dates.length) return false;

    let now = Vue.prototype.$moment(new Date());

    for (let k = 0; k < array_dates.length; k++) {
      let str_elemnt = array_dates[k];
      var date_values = dates_collection[str_elemnt];
      if (!date_values) continue;
      let date_element = Vue.prototype.$moment(str_elemnt, "YYYY-MM-DD"); // display only time or Tomorrow + time or day name + time

      //--- if the first element is today
      if (date_element.isSame(Vue.prototype.$moment(now), "day")) {
        //--- check the time depend on today
        for (let i = 0; i < date_values.length; i++) {
          let full_open_at = Vue.prototype.$moment(
            now.format("YYYY-MM-DD") + " " + date_values[i].opens_at,
            "YYYY-MM-DD HH:mm:ss"
          );
          let full_close_at = Vue.prototype.$moment(
            now.format("YYYY-MM-DD") + " " + date_values[i].closes_at,
            "YYYY-MM-DD HH:mm:ss"
          );
          if (
            now.isSameOrAfter(full_open_at) &&
            now.isSameOrBefore(full_close_at)
          ) {
            return true;
          }
        }
      }
    }
    Vue.nextTick(() => {
      return false;
    });
  },

  getOpeningTimesReadable(isOpen, openingHoursReadable, orderType) {
    let obj = {};
    let objReadable = {};
    obj.open = isOpen;
    obj.status = isOpen ? i18n.t('text.open') : i18n.t('text.closed');
    obj.openingRedable = [];

    switch (orderType) {
      case enumHelper.orderType.Collection:
        objReadable = openingHoursReadable.pickup;
        break;
      case enumHelper.orderType.Delivery:
        objReadable = openingHoursReadable.delivery;
        break;
      case enumHelper.orderType.Table:
        objReadable = openingHoursReadable.tableordering;
        break;
      default:
        objReadable = openingHoursReadable.opening;
        break;
    }
    if (objReadable) {
      Object.keys(objReadable).forEach(function (key) {
        let today = Vue.prototype.$moment().format("dddd") == key;
        if (today) obj.todayTime = objReadable[key];
        obj.openingRedable.push({
          name: key,
          time: objReadable[key],
          isToday: today,
        });
      });
    }
    return obj;
  },

  getOrderTypeText: function (type) {
    switch (type) {
      case enumHelper.orderType.Delivery:
        return i18n.t('text.delivery')
      case enumHelper.orderType.Collection:
        return i18n.t('text.collection')
      case enumHelper.orderType.Table:
        return i18n.t('text.table')
    }
  },
  generateFromatedAddress: function (objAddress, inline = false) {
    if (!objAddress) return "";
    let strAddress = `${objAddress.street_number ? objAddress.street_number : ''
      } ${objAddress.address_line_1 ? objAddress.address_line_1 : ''} `;

    if (objAddress.address_line_2)
      strAddress += objAddress.address_line_2 + " ";

    if (inline) strAddress += "<br>";
    strAddress += `${objAddress.city ? objAddress.city : ''} `
    if (inline) strAddress += "<br>";
    strAddress += `${objAddress.region ? objAddress.region : ""} `;

    if (inline) strAddress += "<br>";
    strAddress += `${objAddress.postcode ? objAddress.postcode : ""}`;

    return strAddress.trim();
  },
  generateFormatedDateTime: function (
    value,
    type = "date",
    fromat = "dddd Do MMM  YYYY",
    lang = null
  ) {

    if (type == "date") {

      if (lang != null) {
        const resource = lang == 'en' ? 'en-gb' : lang;
        return Vue.prototype.$moment(value).locale(resource).format(fromat) ;
      } else {
        return Vue.prototype.$moment(value).format(fromat);
      }
    }
    let time = Vue.prototype.$moment(value, "HH:mm");
    return time.format(fromat);
  },
  getMenuItemPrice: function (menuItem, order_type) {
    let price = menuItem.price;
    if (!order_type) return price;

    if (menuItem.is_special) return menuItem.special_price;

    switch (order_type) {
      case enumHelper.orderType.Delivery: {
        price =
          (menuItem.delivery_price && menuItem.delivery_price != "0.00") ?  menuItem.delivery_price :
          (menuItem.price && menuItem.price != 0) ? menuItem.price :
          (menuItem.originalMenuItem.delivery_price && menuItem.originalMenuItem.delivery_price != 0) ? menuItem.originalMenuItem.delivery_price :
          menuItem.originalMenuItem.price;
        break;
      }
      case enumHelper.orderType.Collection: {
        price =
          (menuItem.collection_price && menuItem.collection_price != "0.00") ? menuItem.collection_price :
          (menuItem.price && menuItem.price != 0) ? menuItem.price :
          (menuItem.originalMenuItem.collection_price && menuItem.originalMenuItem.collection_price != 0) ? menuItem.originalMenuItem.collection_price :
          menuItem.originalMenuItem.price;
        break;
      }
      case enumHelper.orderType.Table: {
        price =
          (menuItem.sitin_price && menuItem.sitin_price != "0.00") ? menuItem.sitin_price :
          (menuItem.price && menuItem.price != 0) ? menuItem.price :
          (menuItem.originalMenuItem.sitin_price &&  menuItem.originalMenuItem.sitin_price != 0) ?  menuItem.originalMenuItem.sitin_price :
          menuItem.originalMenuItem.price;
        break;
      }
    }
    return price;
  },
  //--- start filter the categories
  $_find(items, _searchTerm, _type, _orderType, predicate) {
    let matches = [];
    if (!items) return null;
    for (let obj of items) {
      var item = Object.assign({}, obj);
      if (_type == "menu" && predicate(item, _searchTerm)) {
        //--- if the category name contain to the _searchTerm => return all the corresponding items by the selected type
        //matches.push(item);
        item.menu_items = this.filterMenuItemByType(item, _orderType);
        if (item.children.length) {
          let subMatches = this.$_find(
            item.children,
            _searchTerm,
            _type,
            _orderType,
            predicate
          );
          if (subMatches.length) {
            matches.push({
              ...item,
              children: subMatches,
            });
          } else {
            item.children = [];
            if (item.menu_items && item.menu_items.length) {
              matches.push(item);
            }
          }
        } else if (item.menu_items && item.menu_items.length) {
          matches.push(item);
        }
      } else {
        item.menu_items = this.filterMenuItem(
          item,
          _searchTerm,
          _type,
          _orderType
        );
        if (item.children.length) {
          let subMatches = this.$_find(
            item.children,
            _searchTerm,
            _type,
            _orderType,
            predicate
          );

          if (subMatches.length) {
            matches.push({
              ...item,
              children: subMatches,
            });
          } else {
            item.children = [];
            if (item.menu_items && item.menu_items.length) {
              matches.push(item);
            }
          }
        } else if (item.menu_items && item.menu_items.length) {
          matches.push(item);
        }
      }
    }
    return matches;
  },
  filterBy(item, _searchTerm) {
    return item.name.toLowerCase().includes(_searchTerm.toLowerCase());
  },
  filterMenuItem(item, _searchTerm, _type, _orderType) {
    if (_type == "menu")
      return item.menu_items.filter(
        (x) =>
          (x.name
            .toLowerCase()
            .includes(_searchTerm.toLowerCase()) ||
            (x.description &&
              x.description
                .toLowerCase()
                .includes(_searchTerm.toLowerCase()))) &&
          helpers.checkIfItemAvailbleByOrderType(_orderType, x)
      );
    else if (_type == "fav")
      return item.menu_items.filter(
        (x) =>
          x.is_favourite &&
          (x.name
            .toLowerCase()
            .includes(_searchTerm.toLowerCase()) ||
            (x.description &&
              x.description
                .toLowerCase()
                .includes(_searchTerm.toLowerCase()))) &&
          helpers.checkIfItemAvailbleByOrderType(_orderType, x)
      );
    /*else if (_type == "deals")
      return item.menu_items.filter(
        x =>
          x.is_special &&
          (x.name.toLowerCase().includes(_searchTerm.toLowerCase()) ||
            (x.description &&
              x.description.toLowerCase().includes(_searchTerm.toLowerCase())))
      );*/
  },
  filterMenuItemByType(item, _orderType) {
    return item.menu_items.filter((x) =>
      helpers.checkIfItemAvailbleByOrderType(_orderType, x)
    );
  },
  $_findSpecial(items, _searchTerm, _orderType) {
    var special = "special";
    // if the searchTerm include part of special : all the special category will be returne
    if (!_searchTerm || special.includes(_searchTerm.toLowerCase())) {
      return items.filter((item) =>
        helpers.checkIfItemAvailbleByOrderType(
          _orderType,
          item.locationMenuItem
        )
      );
    }

    // else , we will search on the category items
    return items.filter(
      (item) =>
        (item.locationMenuItem.name
          .toLowerCase()
          .includes(_searchTerm) ||
          (item.locationMenuItem.description &&
            item.locationMenuItem.description
              .toLowerCase()
              .includes(_searchTerm))) &&
        helpers.checkIfItemAvailbleByOrderType(
          _orderType,
          item.locationMenuItem
        )
    );
  },
  //--- end filter the categories
  getCardNumberWithStars: function (last4) {
    return "**** **** **** " + last4;
  },
  checkDeliveryAvailibality(
    can_make_order,
    selectedLocation,
    total_price,
    fromAddress = false
  ) {
    if (!can_make_order) return null;
    /*if (!selectedLocation.availabe_delivery_postcode) {
      return {
        status: false,
        title: fromAddress
          ? "Please provide a correct address"
          : " Please allow access to your location",
        type: "error"
      };
    }*/

    if (!selectedLocation.availabe_delivery_postcode) {
      return {
        status: false,
        title: i18n.t("generic_error.delivery_search_error"),
        type: "warning",
      };
    }
    //--- return this message if the check is based on address selection
    //--- TODO : Calculate the delivery_fee based on the card order total and available Areas conditions
    if (fromAddress) {
      let deliveryFee = helpers.getDeliveryFee(
        selectedLocation.delivery_condition,
        total_price
      );
      return {
        status: true,
        title: `${i18n.t("text.delivery_fee")} : ${Vue.options.filters.currency(deliveryFee)}`,
        value: deliveryFee,
        type: "success",
      };
    }
    return null; // return null value
  },

  getAllAreasConditions(delivery_condition, sortedBy) {
    if (!delivery_condition) return [];
    let all_values = [];
    delivery_condition.forEach((condition) => {
      all_values = [
        ...all_values,
        ...condition.items.map((item) => ({
          charge: parseFloat(item.charge),
          total: parseFloat(item.total),
        })),
      ];
    });
    return all_values.sort(helpers.compareValues(sortedBy));
  },
  //-- get delivery fee based on the delivery areas locations
  getDeliveryFee(delivery_condition, total_cart) {
    let result = helpers.getAllAreasConditions(delivery_condition, "total");

    if (result.length === 1) return result[0].charge;

    result = result.reverse();

    // get the all charges that have the same total and get the min of the charges
    let result_charges = result.filter((item) => {
      return item.total <= total_cart;
    });

    const charges = result_charges.map((a) => a.charge);

    if (charges.length) return Math.min(...charges);
    else return helpers.getDefaultDeliveryFee(delivery_condition);
  },
  // get minimum cat total to allow a delivery
  getMinimumDeliveryPrice(delivery_condition) {
    let result = helpers.getAllAreasConditions(delivery_condition, "total");
    return result[0].total;
  },

  // get minimum cat total to allow a delivery
  getDefaultDeliveryFee(delivery_condition) {
    let result = helpers.getAllAreasConditions(delivery_condition, "total");
    return result[0].charge;
  },

  compareValues(sortBy) {
    return function innerSort(a, b) {
      if (!a.hasOwnProperty(sortBy) || !b.hasOwnProperty(sortBy)) return 0;

      const varA =
        typeof a[sortBy] === "string" ? a[sortBy].toLowerCase() : a[sortBy];
      const varB =
        typeof b[sortBy] === "string" ? b[sortBy].toLowerCase() : b[sortBy];

      let comparaison = 0;
      if (varA > varB) comparaison = 1;
      else if (varB > varA) comparaison = -1;

      return comparaison;
    };
  },
  roundTimeQuarterHour(time, minutesToRound = 15) {
    let [hours, minutes] = time.split(":");
    hours = parseInt(hours);
    minutes = parseInt(minutes);

    // Convert hours and minutes to time in minutes
    time = hours * 60 + minutes;

    let rounded = Math.ceil(time / minutesToRound) * minutesToRound;

    let rHr = "" + Math.floor(rounded / 60);
    let rMin = "" + (rounded % 60);
    return rHr.padStart(2, "0") + ":" + rMin.padStart(2, "0");
  },
  addQuarterToTime(value) {
    return value.add(15, "minutes");
  },

  getQuarterOrderTimesFromPeriod(date, periodStart, periodEnd) {
    let result = [];
    let dtPeriodeEnd = Vue.prototype.$moment(
      date + " " + periodEnd,
      "YYYY-MM-DD HH:mm"
    );
    let dtPeriodeStart = Vue.prototype.$moment(
      date + " " + periodStart,
      "YYYY-MM-DD HH:mm"
    );

    while (dtPeriodeStart.isSameOrBefore(dtPeriodeEnd)) {
      result.push({
        name: dtPeriodeStart.format("HH:mm"),
      });
      dtPeriodeStart = helpers.addQuarterToTime(dtPeriodeStart);
    }
    return result;
  },
  getPaymentTypeIcon(type) {
    let icon = "";
    switch (type) {
      case enumHelper.paymentType.Cash:
        icon = "k-icon-cash";
        break;
      case enumHelper.paymentType.Card:
        icon = "k-icon-creditcard";
        break;
      case enumHelper.paymentType.ApplePay:
        icon = "k-icon-applepay";
        break;
      case enumHelper.paymentType.GooglePay:
        icon = "k-icon-androidpay";
        break;
    }
    return icon;
  },
  generateMenuItemRating(orderItems) {
    return orderItems
      .filter((item) => item.rating)
      .map((item) => {
        if (item.rating) {
          return {
            id: item.id,
            rating: item.rating,
          };
        }
      });
  },
  getMenuItemDieatriesIcons(menuIetimOrginal) {
    let list = [];
    if (
      !menuIetimOrginal ||
      !menuIetimOrginal.dietaries ||
      !menuIetimOrginal.dietaries.length
    )
      return list;

    menuIetimOrginal.dietaries.forEach((element) => {
      switch (element.id) {
        case enumHelper.DietaryType.HALAL:
          list.push({ icon: "k-icon-halal", name: element.name });
          break;
        case enumHelper.DietaryType.VEGAN:
          list.push({ icon: "k-icon-vegan", name: element.name });
          break;
        case enumHelper.DietaryType.VEGETARIAN:
          list.push({ icon: "k-icon-vegetarian", name: element.name });
          break;
        case enumHelper.DietaryType.NUTS:
          list.push({ icon: "k-icon-contains-nuts", name: element.name });
          break;
        case enumHelper.DietaryType.DAIRYFREE:
          list.push({ icon: "k-icon-dairyfree", name: element.name });
          break;
        case enumHelper.DietaryType.GLUTENFREE:
          list.push({ icon: "k-icon-gluten-free", name: element.name });
          break;
        case enumHelper.DietaryType.KOSHER:
          list.push({ icon: "k-icon-kosher", name: element.name });
          break;
      }
    });
    return list;
  },
  evaluateValue(value) {
    return value ? true : false;
  },
  filterLocationsByOrderType(orderType, locations) {
    switch (orderType) {
      case enumHelper.orderType.Delivery:
        return locations.filter(
          (x) => helpers.canMakeOrder(x).can_accept_delivery
          //x.orderSetting && x.orderSetting.offer_delivery
        );
      case enumHelper.orderType.Collection:
        return locations.filter(
          (x) => helpers.canMakeOrder(x).can_accept_collection
        );
      case enumHelper.orderType.Table:
        return locations.filter(
          (x) => helpers.canMakeOrder(x).can_accept_tableOrdering
        );
    }
  },
  checkIfItemAvailbleByOrderType(orderType, item) {
    switch (orderType) {
      case enumHelper.orderType.Delivery:
        return !!item.allow_delivery;
      case enumHelper.orderType.Collection:
        return !!item.allow_collection;
      case enumHelper.orderType.Table:
        return !!item.allow_sitin;
    }
  },
  getCardBrandIcon(stripe_object) {
    let brand_img = "/img/";
    if (!stripe_object) {
      brand_img += "unknown.svg";
      return brand_img;
    }
    switch (stripe_object.brand) {
      case "Visa":
        brand_img += "Visa.svg";
        break;
      case "MasterCard":
        brand_img += "Mastercard.svg";
        break;
      case "American Express":
        brand_img += "Amex.svg";
        break;
      case "Diners Club":
        brand_img += "Diners-Club.svg";
        break;
      case "Discover":
        brand_img += "Discover-card.svg";
        break;
      default:
        brand_img += "unknown.svg";
        break;
    }
    return brand_img;
  },
  geMessageByStripeErrorCode(error_code) {
    if (error_code.error)
      return error_code.error.message
        ? error_code.error.message
        : error_code.error
          ? error_code.error
          : i18n.t("message.payment_failed");
    else
      return error_code.message
        ? error_code.message
        : i18n.t("message.payment_failed");
  },
  getMessageByStripePaymentIntent(status) {
    let msg = i18n.t('generic_error.error_payment_failed');
    switch (status) {
      case "requires_payment_method":
      case "requires_source":
      case "requires_confirmation":
      case "processing":
      case "canceled": {
        msg = i18n.t("generic_error.stripe_payment_failed");
        break;
      }
    }
    return msg;
  },
  getMessageFromAPIError(data, _default = null) {
    let msg = _default ? _default : i18n.t("generic_error.error_occured");

    
    if (data.error) {
      if (data.error.details && typeof data.error.details === 'object' ) {
        let keys = Object.keys(data.error.details);
        keys.forEach((key) => {
          msg = Array.isArray(data.error.details[key])
            ? data.error.details[key][0]
            : data.error.details[key];
        });
      } else {
        msg = data.error.message
          ? data.error.message
          : data.error
            ? data.error
            : msg;  
      }
    } else if (data.errors) {
      let keys = Object.keys(data.errors);
      keys.forEach((key) => {
        msg = data.errors[key][0];
      });
    }
    return msg;
  },
  getLastOrderStatus(status) {
    let obj = {
      text: i18n.t("text.rejected"),
      color: "#FF0000",
      last_update : status.updated_at
    };
    switch (status.order_status) {
      case enumHelper.orderStatus.PENDING:
        return {
          ...obj,
          ...{
            text: i18n.t("text.pending"),
            color: "#0000FF"
          }
        }
        
      case enumHelper.orderStatus.RECEIVED:
        return {
          ...obj,
          ...{
            text: i18n.t("text.received"),
            color: "#FF6600"
          }
        }
      case enumHelper.orderStatus.ACCEPTED:
        return {
          ...obj,
          ...{
            text: i18n.t("text.accepted"),
            color: "#00FF33"
          }
        }
      case enumHelper.orderStatus.DELIVERY:
        return {
          ...obj,
          ...{
            text: i18n.t("text.delivery"),
            color: "#006600"
          }
        }
      case enumHelper.orderStatus.COMPLETED:
        return {
          ...obj,
          ...{
            text: i18n.t("text.completed"),
            color: "#00FF32"
          }
        }
        case enumHelper.orderStatus.REFUNDED:
          return {
            ...obj,
            ...{
              text: i18n.t("text.refunded"),
              color: "#FF0000"
            }
          }
    }
    return obj;
  },
  controlAvailibilityBeforeCheckout(locationStatus, cart) {
    if (cart === null) return true;

    if (locationStatus.openingHours.suspended) return true;

    if (!locationStatus.can_make_order) return true;

    if (cart.orderType == enumHelper.orderType.Collection) {
      return !locationStatus.can_accept_collection;
    }

    if (cart.orderType == enumHelper.orderType.Delivery) {
      return !locationStatus.can_accept_delivery;
    }
    if (cart.orderType == enumHelper.orderType.Delivery) {
      return !locationStatus.can_accept_delivery;
    }
    if (cart.orderType == enumHelper.orderType.Table) {
      return !locationStatus.can_accept_tableOrdering;
    }

    return true;
  },
  getCookieTimeExpiration() {
    return 30 * 60 * 1000;
  },
  /*getFullOrderStatusHistoric(orderStatus) {
    let obj = {};

    //*********** START REJECTED 
    var element = orderStatus.find(
      (el) => el.order_status == enumHelper.orderStatus.REJECTED
    );
    if (element) {
      obj.rejected = {
        icon: "k-icon-cancel-3",
        timestamp: element
          ? Vue.prototype.$moment(element.updated_at).format("HH:mm")
          : "",
        reached: element ? true : false,
      };

      return obj;
    }
    //*********** END RECEIVED 
    else {
      //*********** START RECEIVED 
      element = orderStatus.find(
        (el) => el.order_status == enumHelper.orderStatus.RECEIVED
      );
      obj.received = {
        icon: "k-icon-history",
        timestamp: element
          ? Vue.prototype.$moment(element.updated_at).format("HH:mm")
          : "",
        reached: element ? true : false,
      };
      //*********** END RECEIVED 

      //*********** START ACCEPTED 
      element = orderStatus.find(
        (el) => el.order_status == enumHelper.orderStatus.ACCEPTED
      );
      obj.accepted = {
        icon: "k-icon-current",
        timestamp: element
          ? Vue.prototype.$moment(element.updated_at).format("HH:mm")
          : "",
        reached: element ? true : false,
      };
      //*********** END ACCEPTED 

      //*********** START DELIVERY 
      element = orderStatus.find(
        (el) => el.order_status == enumHelper.orderStatus.DELIVERY
      );
      obj.delivery = {
        icon: "k-icon-food-1",
        timestamp: element
          ? Vue.prototype.$moment(element.updated_at).format("HH:mm")
          : "",
        reached: element ? true : false,
      };
      //*********** END DELIVERY 

      //*********** START COMPLETED 
      element = orderStatus.find(
        (el) => el.order_status == enumHelper.orderStatus.COMPLETED
      );
      obj.completed = {
        icon: "k-icon-ok",
        timestamp: element
          ? Vue.prototype.$moment(element.updated_at).format("HH:mm")
          : "",
        reached: element ? true : false,
      };
      //*********** END COMPLETED 
    }
    return obj;
  },*/
  showErrorMessageAlert(message, icon = null, color = "red", okText = "OK") {
    let full_message = "";
    full_message += icon
      ? "<p><i class='" + icon + "' style='color:" + color + "' ></i></p>"
      : "";

    full_message += "<p>" + message + "</p>";

    let options = {
      html: true,
      animation: "fade",
      type: "basic",
      backdropClose: false,
      customClass: "confirm",
      okText: okText,
    };
    return new Promise((resolve) => {
      Vue.prototype.$dialog.alert(full_message, options).then(() => {
        resolve(true);
      });
    });
  },
  showMessageConfirmation(
    message,
    icon = null,
    color = "red",
    okText = i18n.t("button.continue"),
    cancelText = i18n.t("button.cancel")
  ) {
    return new Promise((resolve) => {
      let full_message = "";
      full_message += icon
        ? "<p><i class='" + icon + "' style='color:" + color + "' ></i></p>"
        : "";
      full_message += "<p>" + message + "</p>";

      let options = {
        html: true,
        animation: "fade",
        type: "basic",
        backdropClose: false,
        customClass: "confirm",
        okText: okText,
        cancelText: cancelText,
      };
      Vue.prototype.$dialog
        .confirm(full_message, options)
        .then(() => {
          resolve(true);
        })
        .catch(() => {
          resolve(false);
        });
    });
  },
  IsWebView() {
    return (
      !isChrome &&
      !isFirefox &&
      !isSafari &&
      !isOpera &&
      !isIE &&
      !isEdge &&
      !isYandex &&
      !isChromium &&
      !isMobileSafari
    );
  },

  orderHasDeletedMenuItems(order) {
    return (
      order.orderItems.find(function (orderItem) {
        return orderItem.menuItem == null;
      }) != null
    );
  },

  checkRequiredOptions(options) {
    return new Promise((resolve, reject) => {
      options.forEach((option) => {
        if (
          option.is_required &&
          ((!Array.isArray(option.selected) && option.selected == "") ||
            (Array.isArray(option.selected) &&
              option.selected.filter((el) => el !== null).length <= 0))
        ) {
          if (option.type == "RADIO" || option.type == "SELECT") {
            reject(i18n.t("message.select_one_option", { option_name: option.name }));
          }
          if (option.type == "CHECKBOX") {
            reject(i18n.t("message.select_least_one_option", { option_name: option.name }));
          }
        }
      });

      resolve(true);
    });
  },

  getOrderTypeIcon(value) {
    switch (value) {
      case enumHelper.orderType.Delivery:
        return "k-icon-cab";
      case enumHelper.orderType.Collection:
        return "k-icon-pick-up";
      case enumHelper.orderType.Table:
        return "k-icon-table-ordering";
    }
  },
  getViewOrderTitle(id, order_type) {
    return i18n.t('text.get_view_order_title', { order_id: id, type_icon: helpers.getOrderTypeIcon(order_type) })
  },
  validLastOrderDateTime(location, orderType, pickUp) {
    let orderTime = this.generateOrderDateTime(pickUp);

    let dateTimes = [];
    switch (orderType) {
      case enumHelper.orderType.Delivery:
        dateTimes = location.delivery_time;
        break;
      case enumHelper.orderType.Collection:
        dateTimes = location.pickup_time;
        break;
      case enumHelper.orderType.Table:
        dateTimes = location.tableOrdering_time;
        break;
    }

    let array_dates = Object.keys(dateTimes);
    if (array_dates.length <= 0) return false;
    // no time found => can't continue with the ordering

    for (let k = 0; k < array_dates.length; k++) {
      let key = array_dates[k];

      let times = dateTimes[key];
      for (let i = 0; i < times.length; i++) {
        let closes_at = Vue.prototype.$moment(
          Vue.prototype
            .$moment(`${key} ${times[i].closes_at}`)
            .format("YYYY-MM-DD HH:mm:ss"),
          "YYYY-MM-DD HH:mm:ss"
        );

        let opens_at = Vue.prototype.$moment(
          Vue.prototype
            .$moment(`${key} ${times[i].opens_at}`)
            .format("YYYY-MM-DD HH:mm:ss"),
          "YYYY-MM-DD HH:mm:ss"
        );

        if (
          orderTime.isSameOrAfter(opens_at) &&
          orderTime.isSameOrBefore(closes_at)
        )
          return true;
      }
    }

    Vue.nextTick(() => {
      return false;
    });
  },
  generateOrderDateTime(pickUp) {
    let now = Vue.prototype.$moment(new Date());

    if (pickUp.type == enumHelper.PickupTime.ASAP) {
      return Vue.prototype.$moment(now, "YYYY-MM-DD HH:mm:ss");
    }

    return Vue.prototype.$moment(
      Vue.prototype
        .$moment(
          Vue.prototype.$moment(
            helpers.generateFormatedDateTime(
              pickUp.date,
              "date",
              "YYYY-MM-DD"
            ) +
            " " +
            helpers.generateFormatedDateTime(pickUp.time, "time", "HH:mm:ss")
          )
        )
        .format("YYYY-MM-DD HH:mm:ss"),
      "YYYY-MM-DD HH:mm:ss"
    );
  },
  getValueName(values, idValue) {
    let valueFound = values.find((x) => x.id == idValue);
    if (valueFound) return valueFound.name;
    return i18n.t('text.VALUE_NOT_FOUND');
  },
  getValuePrice(values, idValue) {
    let valueFound = values.find((x) => x.id == idValue);
    if (valueFound) return valueFound.price;
    return "";
  },
  checkforAutoCoupon(selectedLocation) {
    if (selectedLocation.coupons && selectedLocation.coupons.length) {
      return selectedLocation.coupons.find((c) => c.auto_applied);
    }
    return null;
  },
  checkOrderItemsAvailibility(order, time, menu) {
    return new Promise((resolve) => {

      const dayNumber = time.format("d");
      const selectedtime = time.format("HH:mm:ss");
      let itemsNotAvailableFor = {
        today: [],
        now: [],
      };
      order.forEach((item) => {
        let isAvailable = true;
        if (item.mealDays.length || item.mealTimes.length) {
          //--- refresh the cart order item from the menu
          let itemFound = helpers.refreshCartOrderItemsData(item, menu);
          if (!itemFound) {
            itemsNotAvailableFor.today.push(item);
          } else {
            //--- check if mealDays is configured => check if the items is available for today
            isAvailable = this.orderItemsAvailibilityforToday(
              itemFound,
              dayNumber
            );
            if (!isAvailable) {
              itemsNotAvailableFor.today.push(itemFound);
            }

            if (
              isAvailable &&
              !this.orderItemAvailibilityforNow(itemFound, selectedtime)
            ) {
              itemsNotAvailableFor.now.push(itemFound);
            }
          }
        }
      });
      resolve(itemsNotAvailableFor);
    });
  },
  orderItemsAvailibilityforToday(item, dayNumber) {
    if (item.mealDays.length) {
      let itemFound = item.mealDays.find((mealDay) =>
        mealDay.days.includes(dayNumber)
      );
      return !!itemFound;
    }
    return true;
  },
  orderItemAvailibilityforNow(item, nowTime) {
    if (item.mealTimes.length) {
      let itemFound = item.mealTimes.find(
        (mealTime) => mealTime.start_at <= nowTime && mealTime.end_at >= nowTime
      );
      return !!itemFound;
    }
    return true;
  },
  checkRequiredMenuItemOptions(cart) {
    let result = [];
    return new Promise((resolve, reject) => {
      cart.order.forEach((element) => {
        if (element.hasOptions) {
          helpers.checkRequiredOptions(element.options).catch((ex) => {
            result.push(`<b>${element.name}</b> <br> ${ex}`);
          });
        }
      });

      Vue.nextTick(() => {
        if (result.length) reject(result);
        resolve(true);
      });
    });
  },
  refreshCartOrderItemsData(orderItem, menu) {
    for (let j = 0; j < menu.length; j++) {
      let menuCategory = menu[j];
      let foundOrderItem = menuCategory.menu_items.find(
        (x) => x.id == orderItem.id
      );
      if (foundOrderItem) {
        return helpers.UpdateOrderItem(orderItem, foundOrderItem);
      }
      for (var k = 0; k < menuCategory.children.length; ++k) {
        var menuCategoryChildren = menuCategory.children[k].menu_items;
        foundOrderItem = menuCategoryChildren.find((x) => x.id == orderItem.id);

        if (foundOrderItem) {
          return helpers.UpdateOrderItem(orderItem, foundOrderItem);
        }
      }
    }
    return false; // item not found
  },
  UpdateOrderItem(orderItem, foundOrderItem) {
    orderItem.mealDays = foundOrderItem.mealDays;
    orderItem.mealTimes = foundOrderItem.mealTimes;
    return orderItem;
  },
  pad2(number) {
    return (number < 10 ? '0' : '') + number
  },
  getServiceChargeByType(service_charges, order_type, defaultServiceCharge) {
    const charge = service_charges[order_type];
    return charge ? charge : defaultServiceCharge;
  },
  getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
  }
};
